import styled from 'styled-components';

const ProductReviewsStyled = styled.div`
  .ratingAndReviewBox {
    margin-bottom: 15px;

    .titleBar {
      .rightSide {
        display: none;
      }
    }
    .contentWrapper {
      display: flex;

      @media (max-width: 767px) {
        flex-direction: column;
      }

      .ratingsWrapper {
        width: 100%;
        border-right: 1px solid ${(props) => props?.theme?.color?.lightGray};
        padding: 24px 45px 16px 0;
        display: flex;
        align-items: flex-start;
        flex: 1 1 50%;

        .ratingAverage {
          min-width: 160px;
          height: 150px;
          padding-left: 24px;
          margin-right: 15px;
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;

          @media (max-width: 767px) {
            min-width: 120px;
          }

          .ratingAverageWrapper {
            display: flex;
            flex-direction: column;
            justify-content: center;

            .onRatingBig {
              margin: 5px auto;
            }
          }

          &::after {
            content: '';
            width: 1px;
            height: 163px;
            background: ${(props) => props?.theme?.grey?.iconBg};
            position: absolute;
            right: 0;
            top: 0;
          }

          .reviewCounts {
            font-weight: 600;
            font-size: 13px;
            line-height: 16px;
            color: ${(props) => props?.theme?.text?.medium};
            margin: 0 auto;
          }
        }
        .ratingsDivision {
          width: 100%;

          .ratingPercentage {
            display: flex;
            gap: 16px;
            align-items: center;
            margin-bottom: 12px;

            .progress {
              flex-grow: 1;
              height: 4px;
              background-color: ${(props) => props?.theme?.color?.border};

              .progress-bar {
                background-color: ${(props) => props?.theme?.color?.rating};
              }
            }

            .progressValue {
              font-weight: 600;
              font-size: 13px;
              line-height: 16px;
              min-width: 30px;
            }
          }

          .writeReview {
            gap: 8px;
            font-weight: 700;
            font-size: 16px;
            line-height: 20px;
            color: ${(props) => props?.theme?.green?.dark};
            text-decoration: none;
            margin-top: 38px;
            display: flex;
            align-items: flex-end;
            cursor: pointer;
          }
        }

        @media (max-width: 767px) {
          border-right: 0;
        }
      }

      .reviewsWrapper {
        padding: 16px;
        flex: 1 1 50%;

        .reviewTitle {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 0 16px;
          border-bottom: 1px solid ${(props) => props?.theme?.grey?.iconBg};
          font-weight: 700;
          font-size: 17px;
          line-height: 21px;
          color: ${(props) => props?.theme?.text?.dark};

          .viewAllLink {
            font-weight: 700;
            font-size: 16px;
            line-height: 20px;
            color: ${(props) => props?.theme?.green?.dark};
            text-decoration: none;
            cursor: pointer;
          }
        }
        .commentList {
          .commentItem {
            padding: 16px 0;
            border-bottom: 1px solid ${(props) => props?.theme?.grey?.iconBg};
            .ratingAndLikes {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;

              .reviewerName {
                font-weight: 700;
                font-size: 16px;
                line-height: 20px;
                color: ${(props) => props?.theme?.text?.dark};
                margin-bottom: 10px;
              }
              .like {
                min-width: 44px;
                display: flex;
                align-items: flex-start;
                span:first-child{
                  position: relative;
                  top: -3px;
                }
                .likeCounts {
                  font-weight: 700;
                  font-size: 16px;
                  line-height: 20px;
                  color: ${(props) => props?.theme?.text?.medium};
                }
                .likedIconFilled {
                  cursor: pointer;
                }
                &.liked {
                  .likeCounts {
                    color: ${(props) => props?.theme?.green.dark};
                  }
                }
              }
              .commentRatings {
                margin: 0;

                ul {
                  margin: 0 0 10px;

                  li {
                    margin: 0 5px 0 0;
                    cursor: auto;
                  }
                }
              }
            }
            .review {
              font-weight: 700;
              font-size: 15px;
              line-height: 19px;
              color: ${(props) => props.theme.text.dark};
              margin-bottom: 8px;
            }
            .reviewDesc {
              font-weight: 400;
              font-size: 15px;
              line-height: 19px;
              color: ${(props) => props.theme.text.dark};
              word-break: break-all;

              &.short {
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
            }
            .reviewDate {
              font-weight: 600;
              font-size: 14px;
              line-height: 18px;
              color: ${(props) => props.theme.text.medium};
              margin-top: 8px;
            }
            .readLink {
              font-weight: 700;
              font-size: 15px;
              line-height: 19px;
              color: ${(props) => props.theme.green.dark};
              text-decoration: none;
              margin: 4px 0 0px;
              display: inline-block;
              cursor: pointer;
            }
          }
          .noReviewButton{
            margin: 29px 0 13px;
            font-size: 17px;
            line-height: 21px;
          }
        }
      }
    }
    &.columnView {
      .titleBar {
        .rightSide {
          display: flex;
        }
        .writeReview {
          display: flex;
          align-items: flex-end;
          gap: 8px;
          font-weight: 700;
          font-size: 16px;
          line-height: 20px;
          color: ${(props) => props.theme.green.dark};
          text-decoration: none;
          cursor: pointer;
        }
      }
      .contentWrapper {
        flex-direction: column;

        .ratingsWrapper {
          width: 520px;
          max-width: 100%;
          border: 0;

          .ratingsDivision {
            .writeReview {
              display: none;
            }
          }
        }
        .reviewsWrapper {
          .reviewTitle {
            .viewAllLink {
              display: none;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
`;

export default ProductReviewsStyled;